import React from 'react';
import { Button, FailSnail } from 'Permafrost/index';
export const AppCrash = (props) => {
    const { className, id, style } = props;
    const message = props.message || 'Unfortunately the app has encountered a fatal error.';
    return (React.createElement(FailSnail, { className: className, "data-cy": props['data-cy'], id: id, message: message, style: style },
        React.createElement(Button, { variant: "cta", onClick: () => {
                window.location.reload();
            } }, "Refresh")));
};
//# sourceMappingURL=AppCrash.js.map